<template>
  <div>
    <b-container>
      <section>
        <b-row>
          <b-col lg="9">
            <div class="d-flex video-details-head">
              <div class="left">
                <h4 class="course-name mb-0 heading" @click="goToCourseDescription">
                  {{ getSelectedCourse.name }}
                </h4>
                <p class="badge badge-primary">{{ getSelectedCourse.category_name }}</p>
              </div>
              <div class="right">
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class=" mx-0">
          <div class="col-lg-9 p-0 m-0">
            <video-player
              id="edforevideoplayer"
              :video-url="videoUrl"
              :type-of-player="typeOfPlayer"
              @playNextVideo="playNextVideo"
            />
          </div>
          <div class="col-lg-3 p-0 m-0">
            <playlist
              :is-subscribed="isSubscribed"
              :playlist="videoArray"
              @playVideo="UpdateVideo"
              :nowPlaying="videoData.video_id"
            />
          </div>
        </b-row>
        <div class="video-details">
          <b-row>
            <b-col lg="9">
              <div class="d-flex">
                <div class="left">
                  <div class="d-flex justify-content-between">
                  <h4 class="course-name" @click="goToCourseDescription">
                    {{ videoData.video_name }}
                  </h4>
                  <p>{{ getSelectedCourse.course_duration }}</p>
                  </div>
                  <p>{{ videoData.description }}</p>
                  <div class="d-flex justify-content-between">
                    <b-link :to="{ path: '/courses',query:{ categoryName : getSelectedCourse.category_name ,categoryId:getSelectedCourse.category_id}}"> Find More</b-link>
                    <b-button size="md" @click="buyNow"> Buy Now</b-button>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col></b-col>
          </b-row>
        </div>
      </section>
    </b-container>
  </div>
</template>

<script>
import VideoPlayer from "../components/Templates/videoPlayer";
import Playlist from "../components/Templates/Playlist";
import { mapGetters } from "vuex";
import { store } from "../store/store";

export default {
  components: {
    Playlist,
    VideoPlayer
  },
  computed: {
    ...mapGetters("courses", ["getSelectedCourse"]),
      ...mapGetters("user", ["isAuthenticated"]),
      ...mapGetters("events",["getRedirectToSubscription"])
  },
  name: "play-video",
  data() {
    return {
      videoUrl: "https://studiov2.lyceum.one/webrtc/",
      typeOfPlayer: "iframe",
      playList: [],
      isSubscribed: false,
      videoArray: [],
        videoData: {}
    };
  },
  methods: {
    playNextVideo() {
      if (this.isSubscribed) {
        let index = this.videoArray.findIndex(
          video => video.video_id === this.videoData.video_id
        );
        this.videoUrl = this.videoArray[index + 1].video_url;
        this.videoData = this.videoArray[index + 1];
      }
    },
    UpdateVideo(video) {
      this.videoUrl = video.video_url;
      this.videoData = video;
    },
      goToCourseDescription(){
        this.$router.push({
            path: "/course_description",
            query: {
                courseId: this.getSelectedCourse.course_id,
                courseType: this.getSelectedCourse.isLiveCourse ? "liveCourse" : "course"
            }
        })
      },
      buyNow(){
          if (this.isAuthenticated) {
              this.$router.push({
                  name: "course_subscription",
                  path: "/course_subscription",
                  query: {
                      courseId: this.getSelectedCourse.course_id,
                      isLiveCourse: this.getSelectedCourse.isLiveCourse?"liveCourse" : "course"
                  }
              });
          } else {
              store.dispatch("events/setRedirectToSubscription", true);
              this.$bvModal.show("modal-1");
          }
      }
  },
  mounted() {
    this.videoArray = this.getSelectedCourse.videos;
    this.videoData = this.getSelectedCourse.videos[0];
      this.isSubscribed = this.$route.query.isSubscribed ;
    if (this.getSelectedCourse.isLiveCourse) {
      this.videoUrl = this.getSelectedCourse.videos[0].video_url
        ? this.getSelectedCourse.videos[0].video_url
        : `https://studiov2.lyceum.one/webrtc/?room=${this.getSelectedCourse.room_number}`;
      this.typeOfPlayer = this.getSelectedCourse.videos[0].video_url?"video":"iframe";
    } else {
      this.videoUrl = this.getSelectedCourse.videos[0].video_url;
      this.typeOfPlayer = "video";
    }
  },
    watch:{
        getRedirectToSubscription() {
            if (this.isAuthenticated) {
                this.$router.push({
                    name: "course_subscription",
                    path: "/course_subscription"
                });
            }
        }
    }
};
</script>

<style scoped></style>
